
import { Component, Vue } from 'vue-property-decorator';
import PageFooter from '@/components/page-footer.vue';
import PickerDate from '@/components/picker-date.vue';
import Dialog from '@/components/dialog.vue';
import UploadImg from '@/components/upload-img.vue';
import { imgHost, host } from "@/utils/config";
import {
    bAppMallInit,
    bAppMallSave
} from '@/api/toBApi';

@Component({
    name: '',
    components: {
        PageFooter,
        PickerDate,
        UploadImg,
        'slz-dialog': Dialog,
    }
})
export default class ProductTeaserImage extends Vue {

    private imgUrl = imgHost;
    private uploadApi = host + '/api/image/upload?PlatForm=routuan&Path=image';

    private loading = false;
    private formData = {
        ProductPreviewImgUrl: ''
    }

    private mounted() {
        this.getData();
    }

    private async getData() {
        this.loading = true;
        try {
            const res: any = await bAppMallInit({});
            this.formData = res.Result;
        } catch (error) {

        } finally {
            this.loading = false;
        }
    }
    private uploadSucess(list: any, key: string) {
        this.formData[key] = list[0]
    }
    private async handleSave() {
        this.loading = true;
        try {
            const res: any = await bAppMallSave(this.formData);

            this.$message.success('操作成功');
            this.getData();

        } catch (error) {

        } finally {
            this.loading = false;
        }
    }

}
